import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { User } from 'src/app/core/models/user.model';
import { Holding } from 'src/app/core/models/holding.model';
import { Companie } from 'src/app/core/models/companie.model';
import { UserService } from 'src/app/core/services/user.service';
import { HoldingService } from 'src/app/core/services/holding.service';
import { CompanieService } from 'src/app/core/services/companie.service';

@Injectable({ providedIn: 'root' })
export class UtilsService {
  private actualUser: User;
  private actualHolding: Holding;
  private actualCompany: Companie;

  constructor(
    private userService: UserService,
    private holdingService: HoldingService,
    private companieService: CompanieService,
  ) {}

  async setCompanie(idCompanie: string) {
    const historyCompanie = history.state.companie;
    this.actualCompany = historyCompanie;

    if (!historyCompanie) {
      this.actualCompany = await this.companieService.getCompanie(idCompanie);
    }

    return this.actualCompany;
  }

  async setHolding(idHolding: string) {
    const historyHolding = history.state.holding;
    this.actualHolding = historyHolding;

    if (!historyHolding) {
      this.actualHolding = await this.holdingService.getHolding(idHolding);
    }

    return this.actualHolding;
  }

  async setUser(idUser) {
    const historyUser = history.state.user;
    this.actualUser = historyUser;

    if (!historyUser) {
      this.actualUser = await this.userService.getUser(idUser);
    }

    return this.actualUser;
  }
}
